import React, { useState, useEffect } from 'react';
import { TESTIMONIALS as FALLBACK_TESTIMONIALS } from '../mock';
import { Star, BadgeCheck } from 'lucide-react';

const StarRow = ({ rating, size = 14 }) => (
  <div className="flex gap-0.5">
    {Array.from({ length: 5 }).map((_, i) => (
      <Star
        key={i}
        size={size}
        strokeWidth={0}
        className={i < rating ? 'fill-[#999959] text-[#999959]' : 'fill-[#e5ddce] text-[#e5ddce]'}
      />
    ))}
  </div>
);

const Reviews = () => {
  const reviews = FALLBACK_TESTIMONIALS;

  const total = reviews.length;
  const average = total > 0 ? (reviews.reduce((sum, t) => sum + t.rating, 0) / total).toFixed(1) : '5.0';
  const breakdown = [5, 4, 3, 2, 1].map((star) => ({
    star,
    count: reviews.filter((t) => t.rating === star).length,
  }));

  return (
    <main className="bg-[#FFFFFF] min-h-screen">
      {/* Header / trust summary */}
      <div className="max-w-[900px] mx-auto px-6 pt-16 pb-14 text-center">
        <h1 className="font-serif text-3xl lg:text-4xl text-[#1a1a1a]">Reviews</h1>
        <p className="mt-3 text-[15px] text-[#5a5346]">Thousands of Customers Trust House of Seya</p>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-8 sm:gap-14">
          <div className="text-center">
            <div className="font-serif text-5xl text-[#1a1a1a]">{average}</div>
            <div className="mt-2 flex justify-center"><StarRow rating={Math.round(Number(average))} size={16} /></div>
            <div className="mt-2 text-[11px] tracking-widest-2 uppercase text-[#7a6a54]">{total} Verified Reviews</div>
          </div>
          <div className="flex flex-col gap-1.5 w-full max-w-[260px]">
            {breakdown.map(({ star, count }) => (
              <div key={star} className="flex items-center gap-3 text-[11px] text-[#7a6a54]">
                <span className="w-3">{star}</span>
                <div className="flex-1 h-1.5 bg-[#f0ece1] overflow-hidden">
                  <div
                    className="h-full bg-[#999959]"
                    style={{ width: `${total ? (count / total) * 100 : 0}%` }}
                  />
                </div>
                <span className="w-4 text-right">{count}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Review cards */}
      <div className="max-w-[1300px] mx-auto px-6 lg:px-10 pb-24 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {reviews.map((t, i) => (
          <div key={i} className="bg-[#f7f4ee] p-6 flex flex-col gap-4">
            <div className="flex items-center justify-between">
              <StarRow rating={t.rating} />
              {t.verified && (
                <div className="flex items-center gap-1 text-[10px] tracking-widest-2 uppercase text-[#7a6a54]">
                  <BadgeCheck size={13} strokeWidth={1.6} className="text-[#999959]" />
                  Verified
                </div>
              )}
            </div>
            <p className="text-[14px] text-[#1a1a1a] leading-relaxed flex-1">"{t.quote}"</p>
            <div className="flex items-end justify-between gap-3 pt-2 border-t border-[#e5ddce]">
              <div>
                <div className="text-[13px] font-medium text-[#1a1a1a]">{t.name}</div>
                <div className="text-[11px] tracking-widest-2 uppercase text-[#7a6a54] mt-0.5">{t.location}</div>
              </div>
              {t.product && (
                <div className="text-[11px] text-[#7a6a54] text-right">{t.product}</div>
              )}
            </div>
          </div>
        ))}
      </div>
    </main>
  );
};

export default Reviews;

